<template>
  <div class="earthWrapper">
    <!-- 工具条按钮 -->
    <div class="toolBars">
      <!-- 图层管理的按钮 -->
      <img  v-if="isLayer" id="layerIcon" ref="layerIcon" :src="require('@/assets/images/layerMg_blue.png')" alt="" :class="layerManageClass" @click="openLayerManage">

      <!-- 分屏对比的管理按钮 -->
      <img v-if="layerManageSplitClass === 'layerManageSplit'" id="layerIcon" ref="layerIcon" :src="require('@/assets/images/layerMg_blue.png')" alt="" :class="layerManageSplitClass" @click="openLayerManageSplit">
      
      <div class="analysisBtn">
        <!-- 收起工具条的图标 -->
        <a-button v-if="showTool  && options.length > 1">
          <img :src="require('@assets/images/expandIcon.png')" class="rightArrow" @click="shouqi" />
        </a-button>

        <!-- 左侧插槽 -->
        <slot name='left'></slot>

        <a-button v-if="ifShowTool('区域定位') && showTool" @click="areaLocation">区域定位</a-button>

        <a-button v-if="ifShowTool('识别') && showTool" @click="identify">识别</a-button>

        <a-dropdown v-if="ifShowTool('查询') && showTool" placement="bottomLeft">
          <a-button>查询</a-button>
          <a-menu slot="overlay">
            <a-menu-item key="identify" @click="identify"> 识别 </a-menu-item>
            <a-menu-item key="queryLayer" @click="queryLayer"> 属性查询 </a-menu-item>
          </a-menu>
        </a-dropdown>

        <a-dropdown v-if="ifShowTool('分析') && showTool" placement="bottomLeft" overlayClassName='analysisDropdown'>
          <a-button>分析</a-button>
          <a-menu slot="overlay" @click="handleSummary">
            <a-menu-item key="djfx">叠加分析</a-menu-item>
            <a-menu-item key="hcfx">缓冲分析</a-menu-item>
            <slot name='analysis'></slot>
            <!-- <a-sub-menu key="ztfx" title="专题分析">
              <a-menu-item v-for="item in projectAnalysises" :key='item.bsm'>{{item.name}}</a-menu-item>
            </a-sub-menu> -->
          </a-menu>
        </a-dropdown>

        <!-- 这段查询和识别的代码按王总要求进行优化处理 -->
        <!-- <a-dropdown v-if="ifShowTool('识别') && showTool" placement="bottomLeft">
          <a-button>识别</a-button>
          <a-menu slot="overlay" @click="identify">
            <a-menu-item key="pick_select"> 当前层 </a-menu-item>
            <a-menu-item key="pick_visible"> 所见层 </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-button v-if="ifShowTool('查询') && showTool" @click="queryLayer">查询</a-button>
        <a-dropdown v-if="showTool" placement="bottomLeft">
          <a-button>量算</a-button>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="ls_kuang">框选范围 </a-menu-item>
            <a-menu-item key="ls_yuan">圆形范围 </a-menu-item>
            <a-menu-item key="ls_duobian">多边形范围 </a-menu-item>
            <a-menu-item key="ls_clear">清除 </a-menu-item>
          </a-menu>
        </a-dropdown> -->
        <!-- <a-button v-if="showTool" @click="clickMeasure">图上测量</a-button> -->
        <!-- <a-dropdown v-if="showTool && $route.path != '/documentManage'" placement="bottomLeft">
          <a-button>价值估算</a-button>
          <a-menu slot="overlay" @click="clickJzgs">
            <a-menu-item key="gs">估算 </a-menu-item>
            <a-menu-item key="gsrw">估算任务 </a-menu-item>
          </a-menu>
        </a-dropdown> -->
        <a-dropdown v-if="ifShowTool('对比分析') && showTool" placement="bottomLeft">
          <a-button>对比分析</a-button>
          <a-menu slot="overlay" @click="clickCompareShow" class="compareAnalysis">
            <a-menu-item key="jldb">
              <img src="@/assets/images/checkedIcon.png" alt="" v-if="jldbShow">
              <span>卷帘对比</span>
            </a-menu-item>
            <a-menu-item key="fpdb_tp">
              <img src="@/assets/images/checkedIcon.png" alt="" v-if="fpdbShow_tp">
              <span>双屏对比</span>
            </a-menu-item>
            <slot name='compareAnalysis'></slot>
          </a-menu>
        </a-dropdown>

        <a-button v-if="ifShowTool('我的收藏') && showTool" @click="myCollection">我的收藏</a-button>

        <a-dropdown v-if="ifShowTool('工具') && showTool" placement="bottomLeft">
          <a-button>工具</a-button>
          <a-menu slot="overlay" mode="inline" @click="handleMenuClick">
            <a-menu-item key="zbdw"> 坐标定位 </a-menu-item>
            <a-menu-item key="tscl"> 图上测量 </a-menu-item>
            <a-menu-item key="rzfx"> 日照分析 </a-menu-item>
            <a-menu-item key="cesiumtools"> Cesium工具 </a-menu-item>
            <slot name='tool'></slot>
          </a-menu>
        </a-dropdown>

        <!-- 右侧插槽 -->
        <slot name='right'></slot>

        <!-- 展开工具条的图标 -->
        <img v-if="!showTool" type="left" :src="require('@assets/images/expandIcon.png')" class="leftArrow" @click="zhankai" />
      </div>
    </div>

    <!-- 以下是使用工具时用到的组件 -->
    <!-- 区域定位 -->
    <div v-if="ifShowTool('区域定位') && showTool" class="areaLocation">
      <area-location ref="areaLocation" :qyData='getToolConfiguration("区域定位").qyData' :xjxzq='getToolConfiguration("区域定位").xjxzq' :sjxzq='getToolConfiguration("区域定位").sjxzq'></area-location>
    </div>
    <!-- 分析 -->
    <div v-if="ifShowTool('分析') && showTool" class="analysis">
      <djfx-dialog ref="djfxDialog" :fwData='fwData' v-on="$listeners"></djfx-dialog>
    </div>
    <!-- 识别 -->
    <identify-result v-if="(ifShowTool('识别') || ifShowTool('查询')) && showTool" ref="identify"></identify-result>
    <!-- 查询 -->
    <query-layer-dialog v-if="ifShowTool('查询') && showTool" class='queryLayer' ref="queryLayerDialog" :selectedNode='selectedNode'></query-layer-dialog>
    <!-- 分屏对比 -->
    <div v-if="ifShowTool('对比分析') && showTool" class="splitCompareMap">
      <split-compare-map v-if="fpdbShow_tp" ref="splitCompareMap" v-on="$listeners"></split-compare-map>
    </div>
    <!-- 我的收藏 -->
    <my-collections v-if="ifShowTool('我的收藏') && showTool" class='myCollection' ref="collect" @dblclickData='dblclickData' v-on="$listeners"></my-collections>
    <!-- 坐标定位 -->
    <div v-if="ifShowTool('工具') && showTool" class="pointTrans">
      <point-trans ref="pointTrans"></point-trans>
    </div>
    <!-- 图上测量 -->
    <div v-if="ifShowTool('工具') && showTool" class="measureTool">
      <measure-tools ref="measureTool"></measure-tools>
    </div>
    <!-- 日照分析选择 -->
    <div v-if="ifShowTool('工具') && showTool" class="sunlightAnalysis">
      <sunlight-analysis-dialog ref="sunlightAnalysis"></sunlight-analysis-dialog>
    </div>
    <!-- cesium工具集 -->
    <div v-if="ifShowTool('工具') && showTool" class="cesiumTool">
      <cesium-tools ref="cesiumTool"></cesium-tools>
    </div>

    <slot name='layerManagement'></slot>
  </div>
</template>

<script>
  import AreaLocation from './tools/areaLocation/AreaLocation.vue'
  import DjfxDialog from './tools/analysis/djfxDialog.vue'
  import identifyResult from './tools/identify/identifyResult.vue'
  import queryLayerDialog from './tools/queryLayer/queryLayerDialog.vue'
  import myCollections from './tools/myCollection/myCollections.vue'
  import pointTrans from './tools/pointTrans/pointTrans.vue'
  import measureTools from './tools/measureTools/measureTools.vue'
  import CesiumTools from './tools/commonTools/CesiumTools.vue'
  import splitCompareMap from './tools/compareAnalysis/splitCompareMap.vue'
  import sunlightAnalysisDialog from './tools/sunlightAnalysis/sunlightAnalysisDialog.vue'

  let splitMap = null
  let bufferLayer
  export default {
    name:'ToolBar',
    components: {
      AreaLocation,
      DjfxDialog,
      identifyResult,
      queryLayerDialog,
      myCollections,
      pointTrans,
      measureTools,
      CesiumTools,
      splitCompareMap,
      sunlightAnalysisDialog
    },
    props: {
      options: {
        type: Array,
        default: () => []
      },
      // 系统风格
      systemStyle: {
        type: String,
        default: ''
      },
      isLayer:{
        type: Boolean,
        default: true
      },
      // geoserver配置地址
      geoserverUrl:{
        type: String,
        default: '',
      }
    },
    data() {
      return {
        showTool: true,
        selectedNode:{},// 查询分析-当前图层的数据
        layerManageClass:'layerManage',
        layerManageSplitClass:'layerManage',
        fwData:[],
        jldbShow: false, // 是否选中卷帘对比
        fpdbShow_tp: false, // 是否选中分屏对比
      }
    },
    // beforeDestroy () {
    //   this.$bus.$off('closeAllDialog')
    // },
    methods: {
      initMap(map){
        this.map = map
        console.log('工具初始化',map,mars3d);
        localStorage.setItem('style',this.systemStyle)
        // this.$bus.$on('closeAllDialog',() => {
        //   this.closeAllDialog()
        // })
      },
      // 控制图层管理显示隐藏
      openLayerManage(){
        this.$emit('openLayerManage')
      },
      // 控制分屏对比的图层管理显示隐藏
      openLayerManageSplit(){
        this.$emit('openLayerManageSplit')
      },
      // 控制工具的显示隐藏
      ifShowTool(toolName){
        let showTools = this.options.map(item => item.toolName)
        if(showTools.includes(toolName)){
          return true
        }else{
          return false
        }
      },
      // 获取某个工具的具体配置
      getToolConfiguration(toolName){
        return this.options.filter(item => item.toolName == toolName)[0]
      },
      // 工具栏展开
      zhankai(){
        this.showTool = true
        this.$emit('showToolBar',true)
      },
      // 工具栏收起
      shouqi(){
        this.showTool = false
        this.$emit('showToolBar',false)
      },
      // 区域定位
      areaLocation(){
        this.closeAllDialog()
        this.$refs.areaLocation.setMap(this.map)
        this.clearPatternSpot()
        this.removeBuffer()

        const that = this
        this.map.on(mars3d.EventType.keyup,function (event) {
          console.log('键盘事件！！！',event,that.$refs.areaLocation.escCount);
          // that.$refs.identify.escCount++
          if(event.key == 'Escape' && that.$refs.areaLocation.escCount > 1){
            that.$refs.areaLocation.close()
            console.log(',this.escCount',that.$refs.areaLocation.escCount);
          }
        })
      },
      /**
       * 点击分析 或者 双击我的收藏-分析结果数据触发
       * @param {object} e.domEvent  鼠标点击下拉菜单动作（从我的收藏双击过来的没有）
       * @param {object} e.item  鼠标点击的下拉菜单的信息（从我的收藏双击过来的没有）
       * @param {array} e.keyPath  ['djfx'] 或者 ['hcfx'] 或者 [专题bsm,'ztfx']（从我的收藏双击过来的没有）
       * 
       * @param {string} e.key  'djfx'-指叠加分析 或者 'hcfx'-指缓冲分析 或者 专题bsm-指专题分析
       * @param {string} e.layerId  从我的收藏-分析结果双击节点跳转过来的，选中的图层id
       * @param {number} e.methodsQuery  从我的收藏-分析结果双击节点跳转过来的，选中的空间算法
       * @param {array} e.tjxxData  从我的收藏-分析结果双击节点跳转过来的，统计配置信息表格数据
       * @param {array} e.fwData  从我的收藏-分析结果双击节点跳转过来的，选择范围的表格数据
       * @param {string} e.pageKey  从我的收藏-分析结果双击节点跳转过来的，要跳转的页面key  'djfx'-指叠加分析  'hcfx'-指缓冲分析  专题bsm-指专题分析 'custom-xxx'-指自定义页面
       */
      handleSummary(e){
        console.log('分析',e);
        // 把选择图层的下拉框数据拿到
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        this.$emit('analysisLoadData',e)
      },
      /**
       * 打开分析弹框
       * @param {object} e.domEvent  鼠标点击下拉菜单动作（从我的收藏双击过来的没有）
       * @param {object} e.item  鼠标点击的下拉菜单的信息（从我的收藏双击过来的没有）
       * @param {array} e.keyPath  ['djfx'] 或者 ['hcfx'] 或者 [专题bsm,'ztfx']（从我的收藏双击过来的没有）
       * @param {string} e.key  'djfx'-指叠加分析 或者 'hcfx'-指缓冲分析 或者 专题bsm-指专题分析
       * @param {string} e.layerId  从我的收藏-分析结果双击节点跳转过来的，选中的图层id
       * @param {number} e.methodsQuery  从我的收藏-分析结果双击节点跳转过来的，选中的空间算法
       * @param {array} e.tjxxData  从我的收藏-分析结果双击节点跳转过来的，统计配置信息表格数据
       * @param {array} e.fwData  从我的收藏-分析结果双击节点跳转过来的，选择范围的表格数据
       * @param {string} e.pageKey  从我的收藏-分析结果双击节点跳转过来的，要跳转的页面key  'djfx'-指叠加分析  'hcfx'-指缓冲分析  专题bsm-指专题分析 'custom-xxx'-指自定义页面
       * 
       * @param {array} treeData  选择图层 下拉框数据
       * @param {array} myCollectionTreeData  我的收藏-临时图斑文件夹(供保存图斑使用)、临时图斑文件夹及图斑数据(供选择图斑使用)、分析结果的文件夹(供保存分析结果使用)
       * @param {string} projectName  点击的专题分析-xx专题菜单 名称
       * @param {string} projectBsm  点击的专题分析-xx专题菜单 bsm
       */
      analysisOpenDialog(e,treeData,myCollectionTreeData,projectName,projectBsm){
        let dialogTitle = ''
        switch (e.key) {
          case 'djfx':
            dialogTitle = '叠加分析'
            break;
          case 'hcfx':
            dialogTitle = '缓冲分析'
            break;
          default:
            dialogTitle = '专题分析'
            break;
        }
        this.fwData = e.fwData ? e.fwData : []
        this.$refs.djfxDialog.statisticsConfigTableData = e.tjxxData ? e.tjxxData : []
        this.$refs.djfxDialog.selectLayerBsm = e.layerId ? e.layerId : ''
        // 如果存在layerId，说明是从我的收藏双击过来的
        let action = e.layerId ? '查看' : ''
        let obj = {
          map: this.map,
          treeData: treeData,
          myCollectionTreeData: myCollectionTreeData,
          dialogTitle: dialogTitle,
          projectName: projectName,
          projectBsm: projectBsm,
          action: action,
          pageKey: e.key,
          geoserverUrl: this.geoserverUrl
        }
        this.$refs.djfxDialog.setMap(obj)
      },

      // 识别
      identify(e){
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        let selectNode = this.$slots.layerManagement ? this.$slots.layerManagement[0].componentInstance.selectedNode : null
        this.$refs.identify.identify(e, this.map, selectNode, this.allLayers);
        
        const that = this
        this.map.on(mars3d.EventType.keyup,function (event) {
          console.log('键盘事件！！！',event,that.$refs.identify.escCount);
          // that.$refs.identify.escCount++
          if(event.key == 'Escape' && that.$refs.identify.escCount > 1){
            that.$refs.identify.clearAll(event.key)
            console.log(',this.escCount',that.$refs.identify.escCount);
          }
        })
      },
      // 查询
      queryLayer(){
        console.log('map',this.map);
        this.closeAllDialog()
        this.$refs.queryLayerDialog.setMap(this.map)
      },
      // 对比分析
      clickCompareShow(e){
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        switch (e.key) {
          case 'jldb':
            // 卷帘对比
            if(this.fpdbShow_tp){
              this.fpdbShow_tp = false
              this.closeMapCompare()
            }else if(this.fpdbShow_sp){
              this.fpdbShow_sp = false
              this.closeMapCompare(true)
            }
            
            this.jldbShow = !this.jldbShow
            if(this.jldbShow){
              this.openSplitMap()
            }else{
              this.closeSplitMap()
            }
            break
          case 'fpdb_tp':
            // 分屏对比
            if(this.jldbShow){
              this.jldbShow = false
              this.closeSplitMap()
            }
            
            if(this.fpdbShow_sp){
              this.fpdbShow_sp = false
              this.closeMapCompare(true)
            }

            this.fpdbShow_tp = !this.fpdbShow_tp
            if(this.fpdbShow_tp){
              this.openMapCompare()
            }else{
              this.closeMapCompare()
            }
            break
          case 'fpdb_sp':
            if(this.jldbShow){
              this.jldbShow = false
              this.closeSplitMap()
            }

            if(this.fpdbShow_tp){
              this.fpdbShow_tp = false
              this.closeMapCompare()
            }

            this.fpdbShow_sp = !this.fpdbShow_sp
            if(this.fpdbShow_sp){
              this.openMapCompare(true)
            }else{
              this.closeMapCompare(true)
            }
            break
          default:
            break
        }
      },
      // 清除双屏对比
      closeMapCompare(sp_off) {
        // if (this.map.controls.mapCompare) {
        //   this.map.controls.mapCompare.remove(true)
        // }
        // var divNodes = document.getElementsByClassName('cesium-viewer')
        // if (divNodes && divNodes.length > 0) {
        //   divNodes[0].style.width = '100%'
        // }
        this.layerManageSplitClass = 'layerManage'
        this.$refs.splitCompareMap.removeMap()
      },
      // 打开双屏对比
      openMapCompare(sp_on) {   
        this.closeAllDialog()
        console.log('fenp',this.map);
        // this.mapCompare = true 
        const mapOptions2 = this.map.getCurrentOptions() // map.getOptions()
        
        this.$nextTick(()=>{
          this.layerManageSplitClass = 'layerManageSplit'
          this.$emit('openMapCompare',mapOptions2,this.map)
          // // console.log(this.$refs.splitCompareMap);
          // this.$refs.splitCompareMap.mapOptions = mapOptions2
          // // this.$refs.splitCompareMap.mapsplitOptions = mapOptions2
          // this.$refs.splitCompareMap.mainMap = this.map
          // // this.$refs.splitCompareMap.mainMapSplit = splitMap
          // this.$refs.splitCompareMap.initMap(this.$slots.layerManagement[0].componentInstance.treeData)
        })

        // let mapSplit = new mars3d.control.MapCompare({
        //   ...mapOptions2,
        //   insertIndex: 1,
        // })
        // this.map.addControl(mapSplit)

      },
      // 打开双屏对比的同时打开图层管理（初始化）
      openSplitMapCom(map,splitOption,treeData,checkedKeys,expandedKeys,parentDoucment,mainmapDoc){
        this.$refs.splitCompareMap.initMap(map,splitOption,treeData,checkedKeys,expandedKeys,parentDoucment,mainmapDoc)
      },
      // 关闭卷帘对比
      closeSplitMap() {
        if (this.map.controls.mapSplit) {
          this.map.controls.mapSplit.remove()
        }
      },
      // 打开卷帘对比
      openSplitMap() {
        this.closeAllDialog()
        const mapSplit = new mars3d.control.MapSplit({
          id: 'jldb',
          name: '如东年度对比',
          rightLayer: [
            {
              name: '如东2020年度',
              type: 'arcgis',
              usePreCachedTilesIfAvailable: false, //大地2000高斯投影坐标系时，如果是瓦片，请打开此参数
              crs: 'CGCS2000_GK_Zone_3',
              url: '//192.168.1.12:6080/arcgis/rest/services/RDYX2020/MapServer',
              position: { alt: -27 },
            },
          ],
          leftLayer: [
            {
              name: '如东2019年度',
              type: 'arcgis',
              usePreCachedTilesIfAvailable: false, //大地2000高斯投影坐标系时，如果是瓦片，请打开此参数
              crs: 'CGCS2000_GK_Zone_3',
              url: '//192.168.1.12:6080/arcgis/rest/services/RDYX2019/MapServer',
              position: { alt: -27 },
              style: {
                color: {
                  conditions: [['true', 'rgba(255,255,0,0.8)']],
                },
              },
            },
          ],
        })
        this.map.addControl(mapSplit)
      },

      // 点击 我的收藏
      myCollection(){
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        this.$emit('myCollectionLoadData')
      },
      // 拿到数据后打开我的收藏弹框
      myCollectionOpenDialog(tabList){
        this.$refs.collect.showCard(this.map,tabList)
      },
      /**
       * 在我的收藏 双击分析结果后的回调，用于关闭我的收藏弹框，以及传数据
       * @param {string} e.key  'djfx'-指叠加分析 或者 'hcfx'-指缓冲分析 或者 专题bsm-指专题分析
       * @param {string} msg.layerId  选中的图层id
       * @param {number} msg.methodsQuery  选中的空间算法
       * @param {array} msg.fwData  选择范围的表格数据
       * @param {array} msg.tjxxData  统计配置信息表格数据
       * @param {string} msg.attrValue  
       * @param {array} msg.tjxxData  统计配置信息表格数据
       * @param {string} msg.pageKey  要跳转的页面key  'djfx'-指叠加分析  'hcfx'-指缓冲分析  专题bsm-指专题分析 'custom-xxx'-指自定义页面
       */
      dblclickData(msg){
        console.log('dblclickData',msg);
        if(msg.pageKey.includes('custom')){
          this.closeAllDialog()
          this.clearPatternSpot()
          this.removeBuffer()
          this.$emit('showCustomAnalysisResult',msg)
        }else{
          this.handleSummary(msg)
        }
        // // if(msg.key == 'gs'){
        // //   this.$refs.collect.handleClose()
        // //   msg.action = '查看'
        // //   this.openValueEstimateDialog(map,msg.fwData)
        // // }else{
        //   this.handleSummary(msg)
        // // }
      },

      // 工具
      handleMenuClick(e){
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        switch (e.key) {
          case 'zbdw':
            // 坐标定位
            this.toolVisible = false
            this.$refs.pointTrans.setMap(this.map)
            break
          case 'tscl':
            // 图上测量
            this.clickMeasure()
            break
          case 'rzfx':
            // 日照分析
            this.$refs.sunlightAnalysis.open(this.map) 
            break
          case 'cesiumtools':
            // cesium工具
            this.$refs.cesiumTool.init(this.map)
            break
        }
      },
      // 图上量算
      clickMeasure(){
        this.closeAllDialog()
        this.clearPatternSpot()
        this.removeBuffer()
        this.$refs.measureTool.toolVisible = true
        this.$refs.measureTool.addMeasure(this.map)
        // this.$nextTick(() => {
        //   if(Vue.ls.get('Intro_yzttscl_status') !== 'false'){
        //     guide('一张图-图上测量','一张图-图上测量','Intro_yzttscl_status')
        //   }
        // })

        const that = this
        this.map.on(mars3d.EventType.keyup,function (event) {
            console.log('键盘事件！！！',event,that.$refs.measureTool.escCount);
            // that.$refs.identify.escCount++
            if(event.key == 'Escape' && that.$refs.measureTool.escCount > 1){
              that.$refs.measureTool.toolsClose()
              console.log(',this.escCount',that.$refs.measureTool.escCount);
            }
        })
      },
      //移除
      closeAllDialog(msg){
        if(!msg){
          // 没有传msg，说明是dy3d内部组件要通知外部关闭插槽组件
          this.$emit('closeAllDialog')
        }

        if(this.showBuffer){
          this.showBuffer = false
        }
        //关闭我的收藏
        if(this.$refs.collect){
          this.$refs.collect.close()
        }
        // 关闭cesium工具弹框
        if(this.$refs.cesiumTool){
          this.$refs.cesiumTool.toolsClose()
        }
        // 关闭识别弹窗
        if(this.$refs.identify){
          this.$refs.identify.clearAll('pick_clear')
        }
        // 关闭分析弹框
        if(this.$refs.djfxDialog){
          this.$refs.djfxDialog.close()
        }
        // 关闭委托代理汇总弹框
        if(this.$refs.wtdlhzDialog){
          this.$refs.wtdlhzDialog.showMode = false
        }
        //关闭委托代理详情弹窗
        if(this.$refs.wtdlxqDialog){
          this.$refs.wtdlxqDialog.showDetail = false
        }
        //关闭区域定位
        if(this.$refs.areaLocation){
          this.$refs.areaLocation.close()
        }
        //关闭查询分析弹窗
        if(this.$refs.queryLayerDialog){
          this.$refs.queryLayerDialog.close()
        }
        //关闭图上量算弹窗
        if(this.$refs.measureTool){
          this.$refs.measureTool.toolsClose()
        }
        //关闭坐标定位弹窗
        if(this.$refs.pointTrans){
          this.$refs.pointTrans.close()
        }
        //关闭日照分析弹窗
        if(this.$refs.sunlightAnalysis){
          this.$refs.sunlightAnalysis.close()
        }
        // 关闭核算弹框
        if(this.$refs.valueEstimateDialog){
          this.$refs.valueEstimateDialog.close()
        }
        // 关闭核算任务弹框
        if(this.$refs.valueEstimateListDialog){
          this.$refs.valueEstimateListDialog.close()
        }
      },
      // 清除汇总分析里选择和手绘的图斑数据
      clearPatternSpot(){
        if(this.map){
          this.map.getLayers().map(layer => {
            if(layer.options.name == '手绘图层'){
              this.map.removeLayer(layer)
            }
          })
          this.map.graphicLayer.clear()
        }
      },
      // 清除所有缓冲分析的图层
      removeBuffer(){
        if(bufferLayer){
          bufferLayer.clear()
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.earthWrapper {
  width: 100%;
  height: 100%;
  .toolBars {
    width: 100%;
    z-index: 800;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 0;
    #layerIcon:hover {
      cursor: pointer;
    }

    .layerManage {
      width:40px;
      height:40px;
      margin-left:20px
    }

    .layerManageSplit{
      width: 40px;
      height: 40px;
      margin-left: 40%;
    }

    .zcghLayerMange{
      width: 40px;
      height: 40px;
      margin-left: 14%;
    }

    .analysisBtn {
      position: relative;
      margin-right: 10px;
      background: var(--dy3d-primary-bg);
      .rightArrow {
        margin: 0 10px;
      }
      button {
        border-radius: 0px;
        color: #fff;
        font-size: 16px;
        background: transparent;
        // &:first-child{
        //   position: absolute;
        //   left: -30px;
        //   width: 1%;
        //   img{
        //     position: absolute;
        //     top: 22%;
        //     left: 24%;
        //   }
        // }
        &:nth-child(n+2):not(:last-child)::after{
          content: "";
          position: absolute;
          height: 65%;
          width: 1px;
          background: rgba(255,255,255,0.5);
          right: 0;
          top: 20%;
        }
      }
    }
  }
  .identify {
    position:absolute; 
    top:5%; 
    left:73%;
    z-index: 999;
  }
  .myCollection {
    position:absolute; 
    top:7%; 
    right:26.5%;
    z-index: 999;
  }
  .areaLocation {
    position: absolute;
    top: 7%;
    right: 26.5%;
  }
}


.earth-spin {
  position: relative;
  width: 100%;
  height: 100%;

  /deep/.ant-spin {
    max-height: none;
  }
  /deep/.ant-spin-container {
    width: 100%;
    height: 100%;
  }
}



.infoview {
  position: absolute;
  width: 500px;

  top: 10px;
  right: 10px;
  padding: 10px 15px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
}
.infoview-left {
  right: auto;
  left: 10px;
}

.sectionChars {
  // display: none;
  width: calc(100% - 600px);
  height: 250px;
  top: auto;
  left: 56px;
  bottom: 50px;
}

.infoview input,
.infoview select,
.infoview textarea {
  color: #ffffff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
  font-size: 14px;
}

.infoview > div {
  margin-top: 5px;
}

.earth-tree-ct {
  /deep/.ant-drawer {
    top: 40px;
    height: calc(100% - 90px);
    position: absolute;
    z-index: 1;
  }
  /deep/.ant-drawer-left .ant-drawer-content-wrapper {
    right: unset;
  }
  /deep/.ant-drawer-body {
    padding: 12px;
  }
}
.earth-details-popup {
  z-index: 1;
}
.bufferBox {
    width: 25%;
    position: absolute;
    top: 7%;
    right: 0.5%;
    background: rgba(5,19,66,0.5);
    border: 2px solid #008aff70;
    padding: 20px 10px;
    // img{
    //   position: absolute;
    //   top: -3%;
    // }
    .boxTitle{
      position: absolute;
      top: -3%;
      span {
        position: absolute;
        top: 15%;
        left: 25%;
      }
    }
    .boxClose {
      position: absolute;
      top: 3%;
      right: 2%;
    }
    .bufferBtn{
      margin-right: 2%;
      background: rgba(15,97,255,0.5);
      border: 1px solid transparent;
      border-radius: 4px;
      width: 64px;
      // height: 34px;
      font-size: 14px;
      &:last-child{
        background: rgba(255,90,90,0.2);
        color: #FF5A5A;
      }
      &::after{
        background: transparent !important;
      }
    }
    
    span {
      color: #fff;
    }
    .input {
      width: 15%;
      margin: 0 10px;
      background-color: rgba(255,255,255,0.2);
      border:1px solid transparent;
      color: #fff;
    }
  }
  .rightArrow{
    width: 18px;
    height: 18px;
    margin-right: 10px;
    cursor: pointer;
  }
  .planShadowMap{
    height:auto;
    position: absolute;
    top: 10%;
    right: 4%;
    color: #fff;
    z-index: 1;
    padding: 20px;
    /deep/ .ant-row {
      height: 36px;
      display:flex;
      align-items:center;
    }
    /deep/ .ant-col-8 {
      display: flex;
      flex-direction: row-reverse;
      padding-right: 6px;
    }
    /deep/ .ant-col-16 {
      display: flex;
    }
    /deep/ .ant-slider {
      width: 93%;
    }
  }

  //下拉框样式修改
  .ant-dropdown-menu{
    .ant-dropdown-menu-item{
      padding: 7px 13px 7px 13px;
      color: #fff;
      font-size: 14px; 
    }
    /deep/ .ant-dropdown-menu-submenu-title{
        padding: 7px 13px;
        color: #fff !important;
        font-size: 14px;
      }
    .onoffClass{
      font-size: 12px;
      color: rgba(255,255,255,0.5);
    }
  }

  /deep/ .ant-dropdown-menu-submenu-title:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  
  .compareAnalysis {
    /deep/ .ant-dropdown-menu-item {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    img {
      margin-right: 2px;
    }
  }
</style>